import React from "react";
import PathwayTextInputGroup from "../../../../_UI/Components/Inputs/PathwayTextInputGroup";
import styled from "styled-components";
import PathwaySelectInputGroup from "../../../../_UI/Components/Inputs/PathwaySelectInputGroup";
import LoadingSpinner from "../../../../_UI/Components/LoadingSpinner";
import { LoadingSpinnerButton, PathwayLinkButton } from "../../../../_UI/Components/PathwayButtons";
import AlertComponent from "../../../../_UI/Components/Alerts/AlertComponent";
import { GoogleButton, LoginProviderButtonArea, MicrosoftButton } from "../../../../_components/LoginFormV2";
import { GoogleIcon, MicrosoftIcon } from "../../../../_UI/StyledComponents/PathwayIcons";
import useOrganizationNames from "../../../../_hooks/useOrganizationNames";

const ShopifyAppstoreExistingUserLogin = (props) => {
    const mfaRequired = props.appstoreSetup.existingUserMfaRequired;
    const { organizations: allOrganizations } = useOrganizationNames();
    const existingUserAvailableOrgs = allOrganizations || props.appstoreSetup.existingUserAvailableOrgs;

    return (
        <LoginContent>
            {!props.appstoreSetup.existingUserLoginLoading && props.appstoreSetup.existingUserLoginError && (
                <AlertComponent errorMessages={props.appstoreSetup.existingUserLoginError} />
            )}
            {!props.loginSubmitted && !mfaRequired && (
                <FormContainer>
                    <InputFieldContainer>
                        <FieldLabel>Shopify Store</FieldLabel>
                        <PathwayTextInputGroup
                            name={"organizationExternalUUID"}
                            placeHolder="Dein Shopify Store"
                            dataCy="shopify-store"
                            handleChange={props.handleExistingUserLoginChange}
                            disabled={true}
                            value={props.queryParameters.get("shop")}
                        />
                    </InputFieldContainer>
                    <InputFieldContainer>
                        <FieldLabel>E-Mail</FieldLabel>
                        <PathwayTextInputGroup
                            name={"email"}
                            placeHolder="Deine E-Mail-Adresse"
                            dataCy="shopify-email-login"
                            handleChange={props.handleExistingUserLoginChange}
                            value={props.existingUser.email}
                            mandatory
                            autoFocus
                        />
                    </InputFieldContainer>
                    <InputFieldContainer>
                        <FieldLabel>Passwort</FieldLabel>
                        <PathwayTextInputGroup
                            name={"password"}
                            type="password"
                            placeHolder="Dein Passwort"
                            dataCy="shopify-password-login"
                            handleChange={props.handleExistingUserLoginChange}
                            value={props.existingUser.password}
                            mandatory
                        />
                    </InputFieldContainer>
                </FormContainer>
            )}
            {!props.loginSubmitted && mfaRequired && (
                <MfaSection>
                    <VerificationText>
                        Dein Konto ist durch Zwei-Faktor-Authentifizierung geschützt.
                        <br />
                        Bitte gib den 6-stelligen Code aus deiner Authenticator-App ein, um dich anzumelden.
                    </VerificationText>
                    <InputFieldContainer>
                        <FieldLabel>2-Faktor-Code</FieldLabel>
                        <PathwayTextInputGroup
                            type="text"
                            name="mfaCode"
                            placeHolder="6-stelliger Code aus der Authenticator-App"
                            dataCy="shopify-input-mfa-code"
                            handleChange={props.handleExistingUserLoginChange}
                            value={props.existingUser.mfaCode || ""}
                            maxLength="6"
                            autoComplete="one-time-code"
                            autoFocus
                            mandatory
                        />
                    </InputFieldContainer>
                    <BackToLoginArea>
                        <PathwayLinkButton
                            className="px-0"
                            onClick={props.onCancelMfa}
                            disabled={props.appstoreSetup.existingUserLoginLoading}
                            dataCy="shopify-mfa-back"
                        >
                            Zurück zur Anmeldung
                        </PathwayLinkButton>
                    </BackToLoginArea>
                </MfaSection>
            )}
            {props.loginSubmitted && props.appstoreSetup.existingUserLoginLoading && (
                <LoadingContainer>
                    <LoadingSpinner center={true} loading={props.appstoreSetup.existingUserLoginLoading} />
                </LoadingContainer>
            )}
            {props.loginSubmitted &&
                !props.appstoreSetup.existingUserLoginLoading &&
                props.appstoreSetup.existingUserAvailableOrgs && (
                    <OrganizationSelectionContainer>
                        {props.needsEmailCodeVerification && (
                            <EmailVerificationSection>
                                <VerificationText>
                                    Aus Sicherheitsgründen haben wir dir einen Verifizierungscode an deine
                                    E-Mail-Adresse geschickt.
                                    <br />
                                    Bitte gib den Code hier ein, um dich anzumelden.
                                </VerificationText>
                                <InputFieldContainer>
                                    <FieldLabel>E-Mail Verifizierungscode</FieldLabel>
                                    <PathwayTextInputGroup
                                        type="password"
                                        name="emailVerificationCode"
                                        placeHolder="Verifizierungscode eingeben"
                                        dataCy="input-email-code"
                                        handleChange={props.handleExistingUserLoginChange}
                                        value={props.existingUser.emailVerificationCode || ""}
                                        invalidInputMessage=""
                                        submitted={props.loginSubmitted}
                                        mandatory
                                    />
                                </InputFieldContainer>
                            </EmailVerificationSection>
                        )}
                        <InputFieldContainer>
                            <FieldLabel>Account auswählen</FieldLabel>
                            <OrganizationSelectDescription>
                                Bitte wähle das Konto aus, mit dem Du den neuen Shop verbinden möchtest.
                            </OrganizationSelectDescription>
                            <PathwaySelectInputGroup
                                name={"selectedOrganizationExternalUUID"}
                                handleChange={props.handleSelectOrgAndClientChange}
                                value={props.existingUser.selectedOrganizationExternalUUID}
                                nullOptionValue="Bitte wählen Sie"
                            >
                                <option value="createNewOrganization">Neuen Account erstellen</option>
                                {existingUserAvailableOrgs &&
                                    existingUserAvailableOrgs.map((org) => (
                                        <option key={org.externalUUID} value={org.externalUUID}>
                                            {org.name}
                                        </option>
                                    ))}
                            </PathwaySelectInputGroup>
                        </InputFieldContainer>
                    </OrganizationSelectionContainer>
                )}
            <LoginButtonArea>
                <ModernSubmitButton
                    onClick={props.submit}
                    loading={props.appstoreSetup.existingUserLoginLoading}
                    disabled={
                        (!props.loginSubmitted &&
                            !mfaRequired &&
                            (!props.existingUser.email || !props.existingUser.password)) ||
                        (!props.loginSubmitted &&
                            mfaRequired &&
                            !/^\d{6}$/.test(props.existingUser.mfaCode || "")) ||
                        (props.loginSubmitted && props.existingUser.selectedOrganizationExternalUUID === "") ||
                        (props.needsEmailCodeVerification && !props.existingUser.emailVerificationCode)
                    }
                    buttonCyData="shopify-login-button"
                >
                    Anmelden
                </ModernSubmitButton>
            </LoginButtonArea>

            {!props.loginSubmitted && !mfaRequired && (
                <SSOSection>
                    <DividerRow>
                        <span>oder</span>
                    </DividerRow>
                    <LoginProviderButtonArea>
                        <GoogleButton
                            type="button"
                            onClick={props.onGoogleLogin}
                            disabled={props.appstoreSetup.existingUserLoginLoading}
                            data-cy="shopify-sso-google"
                        >
                            <GoogleIcon width="24px" />
                            Google
                        </GoogleButton>
                        <MicrosoftButton
                            type="button"
                            onClick={props.onMicrosoftLogin}
                            disabled={props.appstoreSetup.existingUserLoginLoading}
                            data-cy="shopify-sso-microsoft"
                        >
                            <MicrosoftIcon width="24px" />
                            Microsoft
                        </MicrosoftButton>
                    </LoginProviderButtonArea>
                </SSOSection>
            )}

            <ForgotPasswordArea>
                <PathwayLinkButton className="px-0" onClick={props.toggleForgetPasswordModal}>
                    Passwort vergessen?
                </PathwayLinkButton>
            </ForgotPasswordArea>
        </LoginContent>
    );
};

export default ShopifyAppstoreExistingUserLogin;

const LoginContent = styled.div`
    display: grid;
    row-gap: var(--gap-xxxl);
`;

const FormContainer = styled.div`
    display: grid;
    row-gap: var(--gap-xxxl);
`;

const InputFieldContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    input,
    select {
        height: 45px !important;
    }
`;

const FieldLabel = styled.label`
    font-family: "Inter", sans-serif;
    font-size: 16px;
    color: #1f2937;
    font-weight: 500;
    text-align: left;
`;

const LoginButtonArea = styled.div`
    display: grid;
    grid-template-columns: 1fr;

    button {
        width: 100%;
        height: 45px;
    }
`;

const ForgotPasswordArea = styled.div`
    display: flex;
    justify-content: center;
`;

const SSOSection = styled.div`
    display: grid;
    row-gap: 1rem;
`;

const DividerRow = styled.div`
    display: flex;
    align-items: center;
    text-align: center;
    color: #6b7280;
    font-family: "Inter", sans-serif;
    font-size: 14px;

    &::before,
    &::after {
        content: "";
        flex: 1;
        border-bottom: 1px solid #e9ecef;
    }

    span {
        padding: 0 0.75rem;
    }
`;

const LoadingContainer = styled.div`
    display: grid;
    justify-content: center;
    align-items: center;
    padding: 2rem;
`;

const OrganizationSelectionContainer = styled.div`
    display: grid;
    row-gap: 1.5rem;
`;

const EmailVerificationSection = styled.div`
    display: grid;
    row-gap: 1rem;
    padding: 1rem;
    background-color: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e9ecef;
`;

const MfaSection = styled.div`
    display: grid;
    row-gap: 1rem;
`;

const BackToLoginArea = styled.div`
    display: flex;
    justify-content: center;
`;

const VerificationText = styled.p`
    font-family: "Inter", sans-serif;
    font-size: 14px;
    color: #495057;
    margin: 0;
    line-height: 1.5;
`;

const OrganizationSelectDescription = styled.p`
    font-family: "Inter", sans-serif;
    font-size: 14px;
    color: #6b7280;
    margin: 0 0 0.5rem 0;
    line-height: 1.4;
`;

const ModernSubmitButton = styled(LoadingSpinnerButton)`
    background: #059669;
    border: 1px solid #059669;
    border-radius: 8px;
    height: 45px;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: var(--text-on-brand);
    transition: all 0.2s ease;

    &:hover:not(:disabled) {
        background: #047857;
        border-color: #047857;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(5, 150, 105, 0.3);
    }

    &:focus {
        outline: none;
        box-shadow: 0 0 0 3px rgba(5, 150, 105, 0.1);
    }

    &:disabled {
        background: #d1d5db;
        border-color: #d1d5db;
        cursor: not-allowed;
        transform: none;
        box-shadow: none;
    }
`;
